module.exports = __webpack_public_path__ + "img/chengg.bad6c4ed.png";